async function setIpCountryInSessionStorage() {
    const storageKey = 'ipCountry';

    // Controlla se l'oggetto esiste già nel session storage
    if (!sessionStorage.getItem(storageKey)) {
        // Se non esiste, chiama la funzione per ottenere il paese dall'IP
        const country = await getIpCountry();

        if (country) {
            // Se il paese viene recuperato correttamente, salvalo nel session storage
            sessionStorage.setItem(storageKey, country);
            console.log(`Paese memorizzato: ${country}`);
        } else {
            console.log('Non è stato possibile recuperare il paese dall\'IP.');
        }
    } else {
        console.log('Il paese è già presente nel session storage:', sessionStorage.getItem(storageKey));
    }
}

// Funzione esistente getIpCountry
async function getIpCountry() {
    try {
        const response = await fetch('https://geoip.service.triboo.it/', {
            headers: {
                'Security-Header': '8375tmsQREZA-'
            }
        });

        if (!response.ok) {
            console.error('Errore nella risposta del server:', response.statusText);
            return null;
        }

        const country = await response.text();
        return country;

    } catch (error) {
        console.error("Errore nel recuperare il paese dall'indirizzo IP:", error);
        return null;
    }
}

document.addEventListener("DOMContentLoaded", function() {
    setIpCountryInSessionStorage();
});
